/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PlanOfCareReviewViewModel } from './PlanOfCareReviewViewModel'; 

export function getPlanOfCareReviewOptions(planOfCareReviewId: string, onSuccess?: (result: PlanOfCareReviewViewModel) => void) {
	return queryOptions({
		queryKey: ['plan-of-care-review', planOfCareReviewId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/qa/queries/getplanofcarereview/' + planOfCareReviewId;
			const resp = await axios.get<PlanOfCareReviewViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(planOfCareReviewId)
	});
}